import React, { useState, useEffect } from "react";
import "./City_Home.css";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import { useHistory, useLocation } from "react-router";
import { useDispatch } from "react-redux";
import PackageModal from "../package_modal/PackageModal";
import "bootstrap/dist/css/bootstrap.min.css";
import CallbackPopup from "../../mainUtils/CallbackPopup";
import FeaturedPhotographer from "./FeaturedPhotographer";
import BackToTop from "../BackToTop";
import { Citydetails } from "./citydetails";

export default function CityHome(props) {
  let apiKey = process.env.REACT_APP_URL;
  const history = useHistory();
  const location = useLocation();

  const { city } = props.location.state;

  const imageurl = apiKey + "image/get-city-image-by-id/";
  const citys = localStorage.getItem("city");
  // const [Citydetails, setCitydetails] = useState([]);
  const [displayModal, setDisplayModal] = useState(false);
  const [popupDisplay, setPopupDisplay] = useState(false);
  const [photographers, setPhotographers] = useState(true);

  //? Old <<<<<<<<<<<<<<<<<<<<<<<

  // const getCityname = async (signal) => {
  //   try {
  //     const response = await fetch(apiKey + "/city/get-city-by-name/" + city, { signal });
  //     const cityData = await response.json();
  //     if (cityData.status === true) {
  //       setCitydetails(cityData.data);
  //     } else {
  //       swal("Something went wrong!");
  //       history.push("/");
  //     }

  //     //Fetching photographers for respective city....
  //     fetch(process.env.REACT_APP_URL + "photographer/get-photographer-by-location/" + city)
  //       .then(response => {
  //         return response.json();
  //       })
  //       .then(data => {
  //         if (data && data.length >= 1) {
  //           setPhotographers(data);
  //           console.log(data)
  //         }
  //       })
  //   } catch (err) {
  //     console.log(err); // error => AbortError - user aborted the request.
  //   }
  // };
  // useEffect(() => {
  //   const controller = new AbortController();
  //   const signal = controller.signal;
  //   getCityname(signal);

  //   // clean-up function to abort api request if user returns to home page immediately before fetching the city data.
  //   return () => {
  //     controller.abort();
  //   }
  // }, []);
  // const dispatch = useDispatch();

  //? Old End >>>>>>>>>>>>>>>>>>>>>>>

  // console.log(Citydetails[city])

  return (
    <>
      <CallbackPopup
        popup={popupDisplay}
        closePopup={setPopupDisplay}
        city={Citydetails[city].place}
        callBackForm={false}
      />
      <div className="bordered">
        <div className="card_body">
          <h1> Welcome to {city} </h1>{" "}
          <div className="card-description"> {Citydetails[city].about} </div>{" "}
        </div>{" "}
        <div className="img_random">
          <div className="img_body">
            {" "}
            <img
              onContextMenu={(e) => {
                e.preventDefault();
              }}
              loading="lazy"
              className="image"
              src={Citydetails[city].image_url}
              alt="not found"
            />{" "}
          </div>{" "}
        </div>{" "}
      </div>{" "}
      <div className="second_row">
        <div className="card touristSpots">
          <div className="body_touristSpots">
            <h1>
              {" "}
              {Citydetails[city].place}
              &nbsp;Tourist Spots
            </h1>{" "}
            {Citydetails[city].spot.map((items, index) => (
              <ul className="tourist_spots" id="tourist_spots_ul" key={index}>
                <li id="tourist_spots_li"> {items} </li>{" "}
              </ul>
            ))}{" "}
          </div>{" "}
        </div>{" "}
        <div className="map">
          <iframe
            src={Citydetails[city].map_link}
            className="map_frame"
            title="map"
          ></iframe>{" "}
        </div>{" "}
      </div>{" "}
      <div className="stitle">
        <h1>Featured Photographers :</h1>
      </div>
      {photographers ? (
        <div className="featuredPhotographer-cityHome__container">
          <FeaturedPhotographer
            photographers={photographers}
            city={city}
            setPopupDisplay={setPopupDisplay}
          />
        </div>
      ) : null}
      <Link to="/userDashboard">
        <div className="sBookflex">
          <button className="sBook">
            Book A Shoot at {Citydetails[city].place}
          </button>
        </div>
      </Link>
      <CallbackPopup popup={true} callBackForm={true} />
    </>
  );
}
